export function getBlockTitleForDisplay(title: string) {
  const maxChars = 23
  const _title = title || 'Untitled'

  if (_title.length > maxChars) {
    return _title.slice(0, maxChars) + '...'
  }
  if (_title === '') {
    return 'Untitled'
  }

  return _title
}
